import { Heading, Text, Button } from "@oysterhr/ui"
import type { TFunction } from "react-i18next"
import { ReactNode } from "react"

interface BannerProps {
  backgroundGradient: string
  buttonAction: () => void
  t: TFunction
  href: string
  image?: string
  alt?: string
  dataAnalyticsName?: string
  customText?: string | ReactNode
}
export const MonetizationBanner = ({
  backgroundGradient,
  image,
  alt = "Oyster image",
  buttonAction,
  t,
  dataAnalyticsName,
  customText,
  href,
}: BannerProps) => {
  return (
    <section
      className={`flex rounded-lg p-6 ${backgroundGradient}`}
      data-testid="monetization-banner-section"
    >
      <div>
        <Heading as="h3">{customText || t("title")}</Heading>
        <Text className="mr-2 mt-2">{t("description")}</Text>

        <Button
          as={"a"}
          className="mt-5 w-full md:w-auto"
          data-analytics-name={dataAnalyticsName}
          href={href}
          target="_blank"
          onClick={buttonAction}
        >
          {t("button")}
        </Button>
      </div>

      {image && (
        <figure className="flex hidden items-center md:flex">
          <img className="min-w-36" src={image} alt={alt} />
        </figure>
      )}
    </section>
  )
}
